import { Dispatch } from '@reduxjs/toolkit'
import { loginRequest, loginSuccess, loginFailure, logout } from './slice'
import { AuthError } from './types'
import axios from '../../config/axios'
import { AxiosError } from 'axios'

export const googleLogin = () => async (dispatch: Dispatch) => {
  try {
    console.log('googleLogin: Starting Google login process...')
    dispatch(loginRequest('Redirecting to Google...'))
    
    console.log('googleLogin: Making request to /google/auth...')
    const response = await axios.get('/google/auth')
    const authUrl = response.data
    
    console.log('googleLogin: Received auth URL:', authUrl)

    console.log('googleLogin: Redirecting to:', authUrl)
    window.location.href = authUrl
  } catch (error: unknown) {
    console.error('googleLogin: Error occurred:', error)
    if (error instanceof AxiosError && error.response?.data?.error) {
      dispatch(loginFailure(error.response.data.error as AuthError))
    } else {
      dispatch(
        loginFailure({
          message: 'Failed to initiate Google login',
          details: 'Unknown error occurred',
        }),
      )
    }
  }
}

export const handleGoogleRedirect =
  (code: string, state: string, scope: string, authuser: string, hd: string, prompt: string) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(loginRequest('Redirecting to Google...'))
      const response = await axios.get('/google/redirect', {
        params: {
          code,
          state,
          scope,
          authuser,
          hd,
          prompt,
        },
      })

      if (response.data.success) {
        dispatch(loginSuccess(response.data.data))
        sessionStorage.setItem('lastActiveTime', Date.now().toString())
      } else if (response.data.error) {
        dispatch(loginFailure(response.data.error))
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.data?.error) {
        dispatch(loginFailure(error.response.data.error as AuthError))
      } else {
        dispatch(
          loginFailure({
            message: 'Failed to complete Google login',
            details: 'Unknown error occurred',
          }),
        )
      }
    }
  }

export const refreshUserProfile = () => async (dispatch: Dispatch, getState: any) => {
  try {
    const state = getState()
    const currentUser = state.auth.user
    
    if (!currentUser?.teamMemberInfo?.workdayId || !currentUser?.teamMemberInfo?.email) {
      console.error('Cannot refresh profile: missing workdayId or email')
      return
    }

    console.log('Refreshing user profile for:', currentUser.teamMemberInfo.workdayId, currentUser.teamMemberInfo.email)
    console.log('Current jobProfile:', currentUser.teamMemberInfo.jobProfile)

    const response = await axios.get('/teamMember/getTeamMember', {
      params: {
        workdayId: currentUser.teamMemberInfo.workdayId,
        email: currentUser.teamMemberInfo.email
      }
    })

    if (response.data && response.data._id) {
      console.log('Fresh data from backend:', response.data)
      console.log('New jobProfile:', response.data.jobProfile)
      
      // Update the teamMemberInfo with the fresh data from the backend
      const updatedUser = {
        ...currentUser,
        teamMemberInfo: {
          ...currentUser.teamMemberInfo,
          ...response.data
        }
      }
      
      console.log('Updated user object:', updatedUser)
      console.log('Updated jobProfile:', updatedUser.teamMemberInfo.jobProfile)
      
      dispatch(loginSuccess({
        tokens: state.auth.tokens,
        user: updatedUser,
        redirectUrl: ''
      }))
      
      console.log('Profile refresh completed')
    } else {
      console.error('Backend response not successful:', response.data)
    }
  } catch (error: unknown) {
    console.error('Failed to refresh user profile', error)
  }
}

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    await axios.post('/logout')
    dispatch(logout())
  } catch (error) {
    console.error('Logout failed', error)
  }
}
